export const WEEKDAY_ITEMS: { id: string; name: string }[] = [
    { id: "1", name: "Sunday" },
    { id: "2", name: "Monday" },
    { id: "3", name: "Tuesday" },
    { id: "4", name: "Wednesday" },
    { id: "5", name: "Thursday" },
    { id: "6", name: "Friday" },
    { id: "7", name: "Saturday" },
];

export type EventTypeItem = {
    id: string;
    name: string;
    keywords: string[];
};

export const EVENT_TYPE_ITEMS: EventTypeItem[] = [
    {
        id: "CONCERT",
        name: "Concert",
        keywords: ["music", "live", "band", "jazz", "dj", "performance", "symphony"],
    },
    {
        id: "COMEDY",
        name: "Comedy",
        keywords: ["stand-up", "standup", "improv", "comedian", "funny"],
    },
    {
        id: "COMMUNITY",
        name: "Community",
        keywords: ["meetup", "neighborhood", "civic", "gathering", "social"],
    },
    {
        id: "SPORTS",
        name: "Sports",
        keywords: ["fitness", "yoga", "run", "game", "marathon", "workout"],
    },
    {
        id: "TRIVIA",
        name: "Trivia",
        keywords: ["quiz", "game night", "pub quiz"],
    },
    {
        id: "KIDS",
        name: "Kids",
        keywords: ["family", "children", "storytime", "youth", "toddler"],
    },
    {
        id: "EDUCATION",
        name: "Education",
        keywords: ["workshop", "lecture", "class", "seminar", "learning", "talk"],
    },
    {
        id: "ART",
        name: "Art",
        keywords: ["gallery", "museum", "exhibition", "craft", "paint"],
    },
    {
        id: "FESTIVAL",
        name: "Festival",
        keywords: ["fair", "market", "parade", "celebration", "carnival"],
    },
    {
        id: "OTHER",
        name: "Other",
        keywords: ["misc", "general"],
    },
    {
        id: "BAR",
        name: "Bar",
        keywords: ["cocktail", "pub", "brewery", "wine", "drinks", "nightlife"],
    },
    {
        id: "HAPPY_HOUR",
        name: "Happy Hour",
        keywords: ["happy hour", "happy-hour", "drink special", "half off", "2-for-1"],
    },
    {
        id: "VOLUNTEER",
        name: "Volunteer",
        keywords: ["charity", "cleanup", "service", "fundraiser"],
    },
    {
        id: "FOOD",
        name: "Food",
        keywords: ["dining", "brunch", "tasting", "culinary", "restaurant", "chef"],
    },
    {
        id: "NETWORKING",
        name: "Networking",
        keywords: ["professional", "career", "mixer", "business", "startup"],
    },
];

export function eventTypeMatchesQuery(
    item: EventTypeItem,
    query: string
): boolean {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    if (item.name.toLowerCase().includes(q)) return true;
    if (item.id.toLowerCase().includes(q)) return true;
    return item.keywords.some((kw) => kw.toLowerCase().includes(q));
}
